<template>
  <div>
    <Dialog
      width="700px"
      :height="createRenderType == 'mobile' ? 'calc(100vh - 50px)' : '618px'"
      titleAlign="left"
      :title="$$t('create.vocal')"
      :subTitle="$$t('create.vocal_subtitle2')"
      :visible="renderData.visible"
      @close="onClose"
      customClass="add-music-vocal-dialog"
      mobileRenderType="drawerDialog"
    >
      <div
        class="height-all add-music-vocal flex-column"
        :class="`add-music-vocal--${createRenderType}`"
      >
        <!-- <div class="add-music-vocal-edit-tip">
          The degree of melody change is related to how smoothly you vocal.
        </div> -->
        <!-- <div
          class="add-music-vocal-edit"
          v-if="tools.isDev() && renderData.openUserVocal"
        >
          <AddFileOrLink @saveSuccess="onSaveSuccess"></AddFileOrLink>
        </div> -->

        <div
          class="add-music-vocal-edits"
          :class="{
            'add-music-vocal-edits-disable': !userDataStore.isLogin,
          }"
          v-if="renderData.openNewVocal"
        >
          <!-- <AddFileOrLink @saveSuccess="onSaveSuccess"></AddFileOrLink> -->
          <div class="add-music-vocal-edit-item flex1 width-0">
            <AddMusicVocalFile
              @showSubscribeDialog="showSubscribeDialog"
              @saveSuccess="onSaveSuccess"
            ></AddMusicVocalFile>
          </div>

          <div
            class="add-music-vocal-edit-item flex1 width-0"
            v-if="ModuleOpenStateControl.speControl.linkCrawling"
          >
            <AddMusicVocalLink
              @showSubscribeDialog="showSubscribeDialog"
              @saveSuccess="onSaveSuccess"
            ></AddMusicVocalLink>
          </div>
        </div>

        <div class="add-music-vocal-tab-box" v-if="renderData.openNewVocal">
          <el-tabs v-model="renderData.activeTab" @tab-click="onTabClick">
            <el-tab-pane :label="$$t('create.library')" name="library">
            </el-tab-pane>
            <el-tab-pane
              :label="$$t('create.used')"
              name="used"
              :disabled="!userDataStore.isLogin"
            >
            </el-tab-pane>
            <el-tab-pane
              :label="$$t('create.mine')"
              name="mine"
              :disabled="!userDataStore.isLogin"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
        <div
          class="add-music-vocal-tab-content flex1 height-0"
          ref="referListParentBox"
        >
          <referMusicListAll
            v-show="renderData.activeTab == 'library'"
            :isCurShow="renderData.activeTab == 'library'"
            @apply="doApply"
            @cancel="doCancel"
            @more="doMore"
          ></referMusicListAll>
          <ReferMusicListUsed
            v-if="renderData.openNewVocal"
            :isCurShow="renderData.activeTab == 'used'"
            v-show="renderData.activeTab == 'used'"
            @apply="doApply"
            @cancel="doCancel"
            @more="doMore"
          ></ReferMusicListUsed>

          <referMusicListUpload
            v-if="renderData.openNewVocal"
            v-show="renderData.activeTab == 'mine'"
            :isCurShow="renderData.activeTab == 'mine'"
            @apply="doApply"
            @cancel="doCancel"
            @more="doMore"
            @editSongTitle="doEditSongTitle"
            @delete="doDelete"
          ></referMusicListUpload>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import tools from "@/utils/tools.js";
import globleConfig, { ModuleOpenStateControl } from "@/config/config.js";

import { useRouter, useRoute } from "vue-router";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import ReferenceItem from "./referenceItem.vue";
import AddMusicVocalFile from "./addFile.vue";
import AddMusicVocalLink from "./addLink.vue";
import AddFileOrLink from "./addFileOrLink.vue";
import ReferMusicListAll from "./referMusicListAll.vue";
import ReferMusicListUsed from "./referMusicListUsed.vue";
import referMusicListUpload from "./referMusicListUpload.vue";
import message from "@/components/functionCallComponent/message.jsx";
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";
import apiReferMusic from "@/api/api/apiReferMusic.js";
import userReferMusicStore from "@/store/create/vocalMusicStore.js";
import useDraftDataStore from "@/store/create/draftDataStore.js";

import useUserDataStore from "@/store/userDataStore";

import { $$t } from "@/i18n/i18n.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const userDataStore = useUserDataStore();

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const referMusicStore = userReferMusicStore();

const referListParentBox = ref(null);

const tabCodeMap = {
  1: "library",
  2: "used",
  3: "mine",
};
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["update:visible", "apply", "showSubscribeDialog"]);
const renderData = reactive({
  visible: props.visible,
  clipSourceData: null,
  activeTab: userDataStore.isLogin
    ? tabCodeMap[referMusicStore.curUseMusicTabCode ?? 1]
    : tabCodeMap[1],
  moreDialogVisible: false,
  reportDialogVisible: false,
  reportSmId: null,
  reportItem: null,
  openNewVocal: ModuleOpenStateControl.create.vocalCustom,
});

const showSubscribeDialog = (...args) => {
  emits("showSubscribeDialog", ...args);
};

const onClose = () => {
  renderData.visible = false;
};

const doApply = (item, tabCode, isback = true) => {
  referMusicStore.setCurUseMusic(item);
  onClose();
  emits("apply");
  // const draftDataStore = useDraftDataStore();
  // let saveData = {
  //   feed_id: draftDataStore.feed_id,
  //   control_type: 3,
  //   control_resource_id: item.id,
  // };
  // const closeMsg = message.loading({ content: "Saving ..." });
  // apiReferMusic
  //   .saveReferenceMusic(saveData)
  //   .then((res) => {
  //     closeMsg.clear();
  //     if (res.code == 200) {
  //       referMusicStore.setCurUseMusic(item);
  //       onClose();
  //     } else {
  //       if (res.code == "9223") {
  //         message.error({
  //           position: 'top', content: "The reference song has been deleted and cannot be used" });
  //       } else if (res.code == "9225") {
  //         message.error({
  //           position: 'top', content: "This reference music has been removed, please select again" });
  //       } else {
  //         message.error({
  //            position: 'top', content: res.msg ?? "save failed" });
  //       }
  //       return;
  //     }
  //   })
  //   .catch((err) => {
  //     closeMsg.clear();
  //   });
};

const doCancel = (item) => {
  referMusicStore.setCurUseMusic(null);
};

const doMore = (item) => {
  renderData.reportItem = item;
  renderData.reportSmId = item.id;
  if (renderData.activeTab == "mine") {
    renderData.moreDialogVisible = true;
  } else {
    renderData.reportDialogVisible = true;
  }
};

const doDelete = (item, tabCode) => {
  referMusicStore.deleteReferItem(item, tabCode);
};

const doEditSongTitle = (item, tabCode) => {
  referMusicStore.doEditSongTitle(item, tabCode);
};

const onSaveSuccess = (ref) => {
  renderData.activeTab = "mine";
  // referMusicStore.setCurUseMusic(ref);
  referMusicStore.insertUploadData(ref);
  // onClose();
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);
const onTabClick = () => {};
onMounted(() => {
  nextTick(() => {
    setTimeout(() => {
      [
        ...referListParentBox.value?.querySelectorAll(`.audio-item-vocal-box`),
      ].some((item) => {
        if (
          item?.getAttribute("data-vocal-id") ==
          referMusicStore.curUseReferMusic?.id
        ) {
          item?.scrollIntoView?.({ behavior: "smooth" });
          return true;
        }
        return false;
      });
    }, 100);
  });
});
onUnmounted(() => {
  createLayoutStore.setVocalCornerMarkVisible(false);
});
</script>
<style lang="scss">
.add-music-vocal {
  .add-music-vocal-edit {
    height: 42px;
    margin: 17px 40px 20px 40px;
  }

  .add-music-vocal-edits {
    padding: 17px 40px 24px 40px;
    display: flex;
    align-items: center;
    position: relative;
    .add-music-vocal-edit-item {
      &:not(:first-child) {
        margin-left: 8px;
      }
    }
  }
  .add-music-vocal-edit-tip {
    margin-top: 0;
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    color: rgba(148, 173, 255, 1);
    padding: 0 40px;
  }
  .add-music-vocal-tab-box {
    margin: 0px 0 10px 0;
    .el-tabs {
      height: 30px;
    }
    .el-tabs__content {
      display: none;
    }
    .el-tabs__header {
      margin: 0 40px;
      height: 30px;
    }
    .el-tabs__nav-wrap:after {
      display: none;
    }
    .el-tabs__item {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 28px;
      height: 28px;
      color: rgba(255, 255, 255, 0.5);
      padding: 0 14px;
      &.is-active {
        color: #fff;
      }
    }
    .el-tabs__active-bar {
      height: 2px;
      background: #ffffff;
    }
    .el-tabs__content {
      padding-top: 10px;
      height: calc(100% - 30px);
    }
  }
  &.add-music-vocal--mobile {
    .add-music-vocal-edit {
      height: 42px;
      margin: 10px 16px 20px 16px;
    }
    .add-music-vocal-edits {
      padding: 10px 16px 20px 16px;
    }
    .add-music-vocal-tab-box {
      margin: 0px 0 0px 0;
      height: 40px;
      .el-tabs__header {
        margin: 0 16px;
      }
      .el-tabs__item {
        font-size: 16px;
      }
    }
  }
}
</style>
